<template>
  <div class="question">
    <span class="index">{{index}}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Question',
  props: {
    index: String
  }
}
</script>

<style lang="stylus" scoped>
.question
  position relative
  box-sizing border-box
  width 670px
  margin 0 auto
  padding 38px 50px
  line-height 1.2
  border 3px solid rgb(58, 54, 77)
  border-radius 10px
  font-size 32px
  font-family 'PingFang-SC-Medium'

  .index
    display inline-block
    position absolute
    top -3px
    left -3px
    width 40px
    line-height 40px
    text-align center
    font-size 26px
    border-radius 10px 0

  /[data-theme='default'] .index
    background-color $theme-color

  /[data-theme='vip'] .index
    background-color $theme-color-vip
</style>
